import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import InvoicingForm from './InvoicingForm';
import { getPaymentRedirectionLink, setUserInfos } from 'services/store/features/User/actions';
import type { AppDispatch, RootState } from 'services/store/types';

const mapStateToProps = (state: RootState) => ({
  user: state.user,
  config: state.config,
  transfer: state.user.transfer,
  status: state.user.status,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getPaymentRedirectionLink, setUserInfos }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoicingForm);
